import { Contact } from './address-model';

export class RegisteredAgent extends Contact {
  public typeIndicator: RegisteredAgentType;
  public isCRA: boolean; // is commercially registered agent
  public raIdNumber: string;
}

export enum RegisteredAgentType {
  Individual = 'Individual',
  BusinessEntity = 'BusinessEntity'
}
